<script lang="ts">
	import { format } from 'svelte-i18n';
	import { main_menu_editor_open_store } from 'src/stores/ui/main-menu-editor';
	import { ButtonV2, Text } from '@Shelly/shelly-design-system';
</script>

<div class="d-flex gap-s justify-content-between align-items-center">
	<Text styleType="body-small" class="text-color-muted">
		{$format('text_main_menu_settings', {
			default: 'Choose and reorder the shortcuts in your main menu.',
		})}
	</Text>
	<ButtonV2 size="m" variant="secondary" on:click={() => main_menu_editor_open_store.set(true)}>
		{$format('button_edit_main_menu', { default: 'Edit menu' })}
	</ButtonV2>
</div>
